import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    sessionsTable: {
      margin: 10,
    },
    buttonContainer: {
      color: palette.red,
      padding: 0,

      '&:hover': {
        opacity: 0.8,
      },
      '&:disabled': {
        color: palette.gray,
        opacity: 0.5,
      },
      '& .MuiIconButton-root': { padding: 0 },
    },
    icon: {
      height: 15,
      width: 15,
      padding: 0,
      '& .MuiIconButton-root': { padding: 0 },
    },
    checkboxCell: {
      padding: '0 0 0 15px !important',

      '& .MuiCheckbox-root': {
        padding: 0,
      },

      '& span > span > svg': { width: 15, height: 15 },
    },
    removeButton: {
      background: palette.error.main,
      color: palette.error.contrastText,
      marginLeft: 16,

      '&:hover': {
        background: palette.error.dark,
      },
    },
    linkToInstances: {
      textDecoration: 'none',
      color: palette.blue,
    },
    iconCancel: {
      color: palette.red,
      marginLeft: 16,
      height: 15,
      width: 15,
      padding: 0,
      '& .MuiIconButton-root': { padding: 0 },
    },
  });
